export default __webpack_public_path__ + "static/media/pencil-edit.63d6099f.svg";